import ClaimStateAlerts from '@rd-web-markets/shared/dist/claim/ClaimStateAlerts';
import { Button } from '@rd-web-markets/shared/dist/util/buttons';
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import benefitCalculationsService from '../../services/claim/benefit_calculations.service';
import TaxBenefitTable from './TaxBenefitTable';
import AdjustmentOfTradingProfitTable from './AdjustmentOfTradingProfitTable';
import CalculationsOfTaxLiabilityTable from './CalculationsOfTaxLiabilityTable';
import CalculationsOfPayableTaxCreditTable from './CalculationsOfPayableTaxCreditTable';
import ClaimCalculationsQETable from './ClaimCalculationsQETable';
import OldRdec7StepsTable from './OldRdec7StepsTable';
import RdecMergedSchemeTable from './RdecMergedSchemeTable';
import ProfitsChargealbeToCorporationTaxTable from './ProfitsChargealbeToCorporationTaxTable';
import LossMemoTable from './LossMemoTable';
export const BenefitCalculationSection = _ref => {
  let {
    accountType,
    claim,
    saveClaim,
    setClaim,
    setLoading
  } = _ref;
  const [calculations, setCalculations, fetchCalculations] = benefitCalculationsService.useFetchAll({
    claimId: claim.id,
    setLoading
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ClaimStateAlerts, {
    claim: claim
  }), /*#__PURE__*/React.createElement(TaxBenefitTable, {
    claim: claim,
    setClaim: setClaim,
    calculations: calculations,
    refreshCalculations: fetchCalculations
  }), /*#__PURE__*/React.createElement(ClaimCalculationsQETable, {
    claim: claim,
    setClaim: setClaim,
    calculations: calculations,
    refreshCalculations: fetchCalculations
  }), /*#__PURE__*/React.createElement(AdjustmentOfTradingProfitTable, {
    claim: claim,
    calculations: calculations,
    refreshCalculations: fetchCalculations,
    setClaim: setClaim,
    setLoading: setLoading
  }), /*#__PURE__*/React.createElement(ProfitsChargealbeToCorporationTaxTable, {
    claim: claim,
    setClaim: setClaim,
    calculations: calculations,
    refreshCalculations: fetchCalculations
  }), /*#__PURE__*/React.createElement(CalculationsOfTaxLiabilityTable, {
    claim: claim,
    setClaim: setClaim,
    calculations: calculations,
    refreshCalculations: fetchCalculations
  }), /*#__PURE__*/React.createElement(CalculationsOfPayableTaxCreditTable, {
    claim: claim,
    setClaim: setClaim,
    calculations: calculations,
    refreshCalculations: fetchCalculations
  }), /*#__PURE__*/React.createElement(LossMemoTable, {
    claim: claim,
    setClaim: setClaim,
    calculations: calculations,
    refreshCalculations: fetchCalculations
  }), claim.rate_types_qualified_for.sme && /*#__PURE__*/React.createElement(OldRdec7StepsTable, {
    claim: claim,
    setClaim: setClaim,
    calculations: calculations,
    refreshCalculations: fetchCalculations
  }), claim.rate_types_qualified_for.merge_type && /*#__PURE__*/React.createElement(RdecMergedSchemeTable, {
    claim: claim,
    setClaim: setClaim,
    calculations: calculations,
    refreshCalculations: fetchCalculations
  }), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    md: 12,
    className: "text-start"
  }, /*#__PURE__*/React.createElement(Button, {
    as: Link,
    variant: "outline-primary",
    to: "/".concat(accountType, "/claims/").concat(claim.id, "/financial_details/total_costs")
  }, /*#__PURE__*/React.createElement("span", {
    className: "material-icons md-18"
  }, "chevron_left"), " Back"))));
};